<app-navigation></app-navigation>
<app-maintenance></app-maintenance>
<div class="container mainContent">
  <div class="row unselectable headerTitle headline">Mail-Dienst-Verwaltung</div>
  <div class="breakLine"></div>
  <div id="moduleContent" class="row unselectable customContent">
    <ejs-grid
      [dataSource]="dataSource"
      [columns]="columns"
      [allowPaging]="allowPaging"
      [editSettings]="editSettings"
      [pageSettings]="pageSettings"
      [toolbar]="toolbar"
      (actionBegin)="actionBegin($event)">
    </ejs-grid>
  </div>
</div>
<app-footer></app-footer>
